<template>
  <KeyVisualAccountTile>
    <template v-slot:component>
      <CreationComp></CreationComp>
    </template>
  </KeyVisualAccountTile>
</template>

<script setup lang="ts">
import KeyVisualAccountTile from '@/componentsTenant/rahmen/KeyVisualAccountTile.vue'
import CreationComp from '@/components/account-management/accountcreation/CreationComp.vue'
</script>

<style lang="scss" scoped>
.wc-row {
  max-width: 100% !important;
  margin: auto;
}
</style>
